// extracted by mini-css-extract-plugin
module.exports = {"fenceWrapper":"form-region_fenceWrapper_e_1cj","btnGroups":"form-region_btnGroups_1ZbfO"};